import { Customer } from "../../../Domain/Model/Customer";
import CustomerDataSource from "../CustomerDataSource";
import { CustomerAPIEntity } from "./Entity/CustomerAPIEntity";
import { PaginationResult } from "../../../../../Shared/Model/PaginationResult";
import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";


const routeName = `/v1/Customer`;
export default class CustomerAPIDataSourceImpl implements CustomerDataSource {

    //  async createColor(data: Color): Promise<ColorAPIEntity[]> {
    //   try {
    //     // Define los datos que deseas enviar en la petición POST
    //     const postData = {
    //       name: data.name,
    //     };
    
    //     // Realiza la petición POST utilizando axios
    //     const response = await axios.post(baseURL, postData);
    
    //     // Verifica si la respuesta contiene datos
    //     if (response.data.succeeded === true) {
    //       // Mapea los datos de la respuesta al formato de CategoryAPIEntity que esperas
    //       const colors = response.data.succeeded;
    
    //       return colors;
    //     } else {
    //       // Maneja el caso en el que la respuesta no tiene el formato esperado
    //       throw new Error("La respuesta no tiene el formato esperado");
    //     }
    //   } catch (error) {
    //     // Maneja errores de solicitud
    //     console.error("Error al agregar el color:", error);
    //     throw new Error("Error al agregar el color");
    //   }
    // }


    async getCustomers(page = 1, pageSize = 10, search: string = ''): Promise<PaginationResult<CustomerAPIEntity>> {
      try {
        const response = await api.get<ApiResponse<any>>(routeName, {
              params: { page, pageSize, search },
            });
        // console.log(response.data.data);
        const data = response.data.data;

        if (data && Array.isArray(data.items)) {
            const customers: Customer[] = data.items.map((item: Customer) => ({
              userId: item.userId,
              firstName: item.firstName,
              lastName: item.lastName,
              dni: item.dni,
              email: item.email,
              phoneNumber: item.phoneNumber,
              status: item.status,
              customerId: item.customerId,
          }));

          return {
                items: customers,
                page: data.page,
                pageSize: data.pageSize,
                totalCount: data.totalCount,
                hasNextPage: data.hasNextPage,
                hasPreviousPage: data.hasPreviousPage,
              };
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al obtener los clientes:", error);
        throw new Error("Error al obtener los clientes");
      }
    }

    // async updateColor(data: Color): Promise<boolean> {
    //   try {
    //     // Realiza la petición PUT utilizando axios
    //     const response = await axios.put(`${baseURL}/${data.id}`, data);
  
    //     // Verifica si la respuesta contiene datos
    //     if (response.data.succeeded === true) {
    //       // Devuelve true si la actualización fue exitosa
    //       return true;
    //     } else {
    //       // Maneja el caso en el que la respuesta no tiene el formato esperado
    //       throw new Error("La respuesta no tiene el formato esperado");
    //     }
    //   } catch (error) {
    //     // Maneja errores de solicitud
    //     console.error("Error al actualizar el color:", error);
    //     throw new Error("Error al actualizar el color");
    //   }
    // }

    // async removeColor(id: string): Promise<boolean> {
    //   try {
    //     // Realiza la petición DELETE utilizando axios
    //     const response = await axios.delete(`${baseURL}/${id}`);
  
    //     // Verifica si la respuesta contiene datos
    //     if (response.data.succeeded === true) {
    //       // Devuelve true si la eliminación fue exitosa
    //       return true;
    //     } else {
    //       // Maneja el caso en el que la respuesta no tiene el formato esperado
    //       throw new Error("La respuesta no tiene el formato esperado");
    //     }
    //   } catch (error) {
    //     // Maneja errores de solicitud
    //     console.error("Error al eliminar el color:", error);
    //     throw new Error("Error al eliminar el color");
    //   }
    // }
  }